import { Paper, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { ErrorOutlined, InfoOutlined } from '@material-ui/icons';
import classNames from 'classnames';
import React from 'react';

/* */
const styles = (theme) => ({
  paper: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing.unit * 2,
    color: theme.palette.common.white,
    marginBottom: theme.spacing.unit * 2,
  },
  icon: { marginRight: 16 },
  default: { backgroundColor: 'transparent', color: theme.palette.primary.main },
  info: { backgroundColor: '#32B5E5' },
  error: { backgroundColor: '#FF3446' },
  warning: { backgroundColor: '#FFBB32' },
});

const Alert = ({ classes, children, className, variant = 'error', as, ...props }) => {
  const Component = as || Typography;

  return (
    children && (
      <Paper {...props} className={classNames(classes.paper, classes[variant], className)}>
        {variant === 'info' || variant === 'default' ? (
          <InfoOutlined className={classes.icon} />
        ) : (
          <ErrorOutlined className={classes.icon} />
        )}
        <Component color='inherit' variant='body2'>
          {children}
        </Component>
      </Paper>
    )
  );
};

export default withStyles(styles)(Alert);
